import { CRITERIA } from "../../modals/SelectByCriteria/constants";
import { formatTimeString } from "../../modals/SelectByCriteria/model";
import { originalTypes } from "../../../enums/stopTypes";

export const getLabelValue = ({ criteria, value }) => {
  const timeCriteria = [
    CRITERIA.ETA,
    CRITERIA.OPPORTUNITY_TIME,
    CRITERIA.STOP_TIME,
  ];

  if (timeCriteria.includes(criteria)) {
    return formatTimeString(value);
  }
  if (criteria === CRITERIA.HUB_SCAN_DATE_TIME) {
    return formatTimeString(value, "DD-MM-YYYY, hh:mm A");
  }
  if (criteria === CRITERIA.PROPERTY_TYPE) {
    return value.toUpperCase();
  }
  if (criteria === CRITERIA.STOP_TYPE) {
    return Object.values(originalTypes).find(
      ({ stopType }) => stopType === value
    )?.stopTypeDescription;
  }

  return value;
};
